import { render, staticRenderFns } from "./PriceWatchProducts.vue?vue&type=template&id=53b8700f"
import script from "./PriceWatchProducts.vue?vue&type=script&lang=js"
export * from "./PriceWatchProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports